<template>
	<div class="customer-area-page jobs">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation
						page="job-profiles"
						sub-link-active-key="addJobProfile"
					/>
				</b-col>
				<b-col md="6">
					<h1>Neuen Job anlegen</h1>
					<Loading v-if="loading"/>
					<b-row v-else>
						<b-col md="8">
							<div class="title-container">
								<SetJobProfileName
									@save="onAdd"
								/>
							</div>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/customer-area/Navigation"
import Button from "@/vue/common/Button";
import SetJobProfileName from "@/vue/customer-area/SetJobProfileName.vue";
import Loading from "@/vue/common/Loading.vue";
import {redirect} from "@/helper/Window";

export default {

	components: {
		Loading,
		SetJobProfileName,
		Navigation,
		Button,
	},

	data ()
	{
		return {
			loading: false
		};
	},

	methods: {
		onAdd ({jobProfile})
		{
			this.loading = true;

			redirect('/kundenbereich/jobs/' + jobProfile.id);
		}
	}
}
</script>
